import { createFileRoute } from '@tanstack/react-router';
import { ScopeSettingsPage } from '../../../features/B5/scope-settings-page';

/** W2-2-3: /settings/segments/:segment — the alert settings of one segment ("ענף ליסינג רכב"). */
export const Route = createFileRoute('/_app/settings/segments/$segment')({
  component: SegmentSettings,
});

function SegmentSettings() {
  const { segment } = Route.useParams();
  return <ScopeSettingsPage scope="segment" scopeId={segment} />;
}
